<script lang="ts" setup>
	import {useFilters} from '@/store/filter.store';
	import type {Option} from '@/types/search/filter.option';
	import {storeToRefs} from 'pinia';
	import {useProductTableStore} from '@/store/table.store';

	const emit = defineEmits(['filters-updated']);
	const filterStore = useFilters();

	const {loading} = storeToRefs(useProductTableStore());

	const props = defineProps<{
		filterName: string;
		option: Option;
	}>();

	const toggleSelectedFilter = () => {
		filterStore.updateSelectedFilters(props.filterName, props.option.value);
		emit('filters-updated');
	};
</script>

<template>
	<li :id="'filter-checkbox-item_'+ filterName + '_' + option.value.replace(' ','-')"
	    class="filter-checkbox-item">
		<label class="filter-checkbox-label">
			<input
					:checked="option.active"
					:disabled="loading"
					:name="filterName"
					:value="option.value"
					type="checkbox"
					@input="toggleSelectedFilter()" />

			<span class="filter-checkbox-icon"></span>

			<span class="filter-checkbox-text">
				<span v-if="option.iconStyle" class="icon-color" v-bind:style="option.iconStyle"></span>
				{{ option.label }}
			</span>
			<span class="filter-checkbox-count">{{ option.amount }}</span>
		</label>
	</li>
</template>
